import PropTypes from "prop-types";
import React, { Component } from "react";
import Dialog from "./dialog";
import Button from "components/form/button";
import Globalize from "globalize";
import { DATATEST } from "constants/integration";

/** @augments {Component<any, any>} */
export class AlertDialog extends Component {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        onRequestClose: PropTypes.func.isRequired,
        actionLabel: PropTypes.string,
        disableButton: PropTypes.bool,
        dismissButton: PropTypes.bool,
    };

    render() {
        const { children, onRequestClose, contentStyle, dismissButton, actionLabel, disableButton, ...props } =
            this.props;
        return (
            <Dialog
                {...props}
                modal={true}
                onRequestClose={onRequestClose}
                contentStyle={Object.assign({ maxWidth: "360px" }, contentStyle)}
                actions={[
                    <Button
                        key="dismiss"
                        data-test={DATATEST.ALERT.DISMISS}
                        label={actionLabel || Globalize.formatMessage("Dismiss")}
                        style={{ width: "100%", display: dismissButton === false ? "none" : "block" }}
                        primary={true}
                        onClick={onRequestClose}
                        disabled={disableButton}
                    />,
                ]}
            >
                {children}
            </Dialog>
        );
    }
}

export default AlertDialog;
